import { redirectObject } from '@legacy/routers/RedirectDesignSeven/redirectObject';

interface IPageItem {
  pageUrl: string;
  pageIdentifier: string;
}

interface IIsAPILoadingLegacyPage {
  pathname: string;
  isLoading: boolean;
  designSevenPageList: Array<IPageItem>;
}

export const LOADING = 'loading';
export const CONTINUE = 'continue';

export const isAPILoadingLegacyPage = ({
  pathname,
  isLoading,
  designSevenPageList,
}: IIsAPILoadingLegacyPage) => {
  if (isLoading) return LOADING;

  if (designSevenPageList.length > 0) {
    const result = Object.entries(redirectObject).map(([key, { oldPaths }]) => {
      const isContainingPageIdentifier = designSevenPageList?.find(
        ({ pageIdentifier }) => pageIdentifier === key,
      );
      if (
        isContainingPageIdentifier &&
        oldPaths.some((path) => path === pathname)
      )
        return LOADING;
      return null;
    });
    if (result.some((item) => item === LOADING)) {
      return LOADING;
    }
  }

  return CONTINUE;
};
